define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var Backbone = require('backbone');
    var HeaderView = require('modules/header/index');
    var SidebarView = require('views/sidebar');
    var ModalsFactory   = require('modals/factory');
    var _ = require("underscore");
    var AppConfig = require('config/application');
    var I18n = require('i18n!nls/main');
    var AboutPage = require('../modules/aboutPage/index');
    //var db = require('modules/indexedDb/index');
    var tariffSections = {
            StatsSource             : ['analytics'],

            Statistic               : ['analytics'],
            StatisticLvl2           : ['analytics'],
            StatisticSource         : ['analytics'],
            StatisticDynamics       : ['analytics'],

            Leads                   : ['crm'],
            LeadsImport             : ['crm'],
            LeadsExport             : ['crm'],
            LeadsCard               : ['crm'],

            Deals                   : ['crm'],
            DealsImport             : ['crm'],
            DealsExport             : ['crm'],
            DealsCard               : ['crm'],

            //CodeStandart            : ['callback', 'analytics', 'calltracking', 'hunter'],

            Constructor             : ['crm'],

            WidgetCallback          : ['callback'],
            WidgetSocial            : ['hunter'],
            WidgetGeolocation       : ['analytics'],
            WidgetBlacklist         : ['pbx'],
            WidgetOffers            : ['callback'],

            Popdom                  : ['callback'],
            PopdomEdit              : ['callback'],
            PopdomStats             : ['callback'],

            Contacts                : ['crm', 'hunter'],
            ContactsCard            : ['crm', 'hunter'],

            TelephonyOnline         : ['calltracking'],
            TelephonyOffline        : ['calltracking'],
            TelephonyNumbers        : ['pbx'],
            TelephonyRedirection    : ['pbx'],
            TelephonyWelcome        : ['pbx'],
            TelephonyDetails        : ['pbx'],
            TelephonyComands        : ['pbx'],
            TelephonyRobot          : ['pbx'],
            TelephonyCalltracking   : ['calltracking'],
            //TelephonySimcards       : ['fmc'],

            Sites                   : ['constructor'],

            Crater                  : ['funnel'],
            CraterEdit              : ['crm'],
            CraterDecomposition     : ['funnel'],

            Tasks                   : ['crm'],

            Calendar                : ['crm'],
            MailDomains             : ['crm']
    };

    var Pages = {
        StatsSource         : {
                entry: () => import(/* webpackChunkName: "stat" */ 'pages/stats/source/index')
            },

        Statistic           : {
                entry: () => import(/* webpackChunkName: "stat" */ 'pages/statistic/statistic1')
            },
        //Statistic: 'pages/statistic/statisticNew',
        StatisticLvl2       : {
                entry: () => import(/* webpackChunkName: "stat" */ 'pages/statistic/lvl2')
            },
        //StatisticSource: 'pages/statistic/statisticNew',
        StatisticSource     : {
                entry: () => import(/* webpackChunkName: "stat" */ 'pages/statistic/source')
            },
        StatisticDynamics   : {
                entry: () => import(/* webpackChunkName: "stat" */ 'pages/statistic/dynamics')
            },

        Leads               : {
                entry: () => import(/* webpackChunkName: "leads" */ 'pages/leads/index')
            },
        LeadsImport         : {
                entry: () => import(/* webpackChunkName: "leads" */ 'pages/leads/import')
            },
        LeadsExport         : {
                entry: () => import(/* webpackChunkName: "leads" */ 'pages/leads/export')
            },
        LeadsCard           : {
                entry: () => import(/* webpackChunkName: "leads" */ 'pages/leads/card'),
                hideHeader: true,
            },

        LeadsBuying         : {
                entry: () => import(/* webpackChunkName: "leads" */ 'modules/leadsBuying/index')
            },

        Deals               : {
                entry: () => import(/* webpackChunkName: "leads" */ 'pages/deals/index')
            },
        DealsImport         : {
                entry: () => import(/* webpackChunkName: "leads" */ 'pages/leads/import')
            },
        DealsExport         : {
                entry: () => import(/* webpackChunkName: "leads" */ 'pages/leads/export')
            },
        DealsCard           : {
                entry: () => import(/* webpackChunkName: "leads" */ 'pages/deals/card'),
                hideHeader: true,
            },

        CodeStandart        : {
                entry: () => import(/* webpackChunkName: "code" */ 'pages/code/standart')
            },
        CodeAdvanced        : {
                entry: () => import(/* webpackChunkName: "code" */ 'pages/code/advanced')
            },

        Constructor         : {
                entry: () => import(/* webpackChunkName: "constructor" */ 'pages/constructor')
            },

        WidgetCallback      : {
                entry: () => import(/* webpackChunkName: "widget" */ 'pages/widgets/callback')
            },
        WidgetSocial        : {
                entry: () => import(/* webpackChunkName: "widget" */ 'modules/widgets/social/index')
            },
        WidgetSpeech        : {
                entry: () => import(/* webpackChunkName: "widget" */ 'pages/widgets/speech')
            },
        WidgetGeolocation   : {
                entry: () => import(/* webpackChunkName: "widget" */ 'pages/widgets/geolocation')
            },
        WidgetBlacklist     : {
                entry: () => import(/* webpackChunkName: "widget" */ 'pages/widgets/blacklist/index')
            },
        WidgetOffers        : {
                entry: () => import(/* webpackChunkName: "widget" */ 'pages/widgets/offers')
            },

        Popdom              : {
                entry: () => import(/* webpackChunkName: "widget" */ 'pages/widgets/popdom')
            },
        PopdomEdit          : {
                entry: () => import(/* webpackChunkName: "widget" */ 'pages/widgets/popdom_edit')
            },
        PopdomStats         : {
                entry: () => import(/* webpackChunkName: "widget" */ 'pages/widgets/popdom_stats')
            },

        Partners            : {
            entry: () => import(/* webpackChunkName: "partners" */ 'pages/partners/partnersNew')
            },
        PartnersPromo       : {
                entry: () => import(/* webpackChunkName: "partners" */ 'pages/partners/partners_promo')
            },

        PollPage            : {
                entry: () => import(/* webpackChunkName: "contacts" */ 'pages/poll/index')
            },
        Contacts            : {
                entry: () => import(/* webpackChunkName: "contacts" */ 'pages/contacts/main')
            },
        ContactsCard        : {
                entry: () => import(/* webpackChunkName: "contacts" */ 'pages/contacts/card')
            },

        TelephonyOnline     : {
                entry: () => import(/* webpackChunkName: "telephony" */ 'pages/telephony/online')
            },
        TelephonyOffline    : {
                entry: () => import(/* webpackChunkName: "telephony" */ 'pages/telephony/offline')
            },
        TelephonyNumbers    : {
                entry: () => import(/* webpackChunkName: "telephony" */ 'pages/telephony/numbers')
            },
        TelephonyRedirection: {
                entry: () => import(/* webpackChunkName: "telephony" */ 'pages/telephony/redirection')
            },
        TelephonyWelcome    : {
                entry: () => import(/* webpackChunkName: "telephony" */ 'pages/telephony/welcome')
            },
        TelephonyDetails    : {
                entry: () => import(/* webpackChunkName: "telephony" */ 'pages/telephony/details/index')
            },
        TelephonyComands    : {
                entry: () => import(/* webpackChunkName: "telephony" */ 'pages/telephony/comands')
            },
        TelephonyRobot      : {
                entry: () => import(/* webpackChunkName: "telephony" */ 'pages/telephony/robot')
            },
        TelephonyCalltracking: {
                entry: () => import(/* webpackChunkName: "telephony" */ 'pages/telephony/calltracking/index')
            },
        TelephonySimcards   : {
                entry: () => import(/* webpackChunkName: "telephony" */ 'pages/telephony/simcards/index')
            },

        Staff               : {
                entry: () => import(/* webpackChunkName: "staff" */ 'pages/staff/staff')
            },
        StaffEdit           : {
                entry: () => import(/* webpackChunkName: "staff" */ 'pages/staff/edit')
            },
        StaffStatistic      : {
                entry: () => import(/* webpackChunkName: "staff" */ 'pages/staff/statistic')
            },
        StaffChangePassword : {
                entry: () => import(/* webpackChunkName: "staff" */ 'pages/staff/change_password')
            },
        StaffSecurity       : {
                entry: () => import(/* webpackChunkName: "staff" */ 'pages/staff/security')
            },
        StaffWorklog       : {
          entry: () => import(/* webpackChunkName: "worklog" */ 'pages/staff/worklog')
        },

        Sites               : {
                entry: () => import(/* webpackChunkName: "sites" */ 'pages/sites/index')
            },

        Crater              : {
                entry: () => import(/* webpackChunkName: "crater" */ 'pages/crater/crater')
            },
        CraterEdit          : {
                entry: () => import(/* webpackChunkName: "crater" */ 'pages/crater/edit/index')
            },
        CraterDecomposition : {
                entry: () => import(/* webpackChunkName: "crater" */ 'pages/crater/decomposition')
            },

        Balance             : {
                entry: () => import(/* webpackChunkName: "balance" */ 'pages/balance/balance')
            },
        BalanceMessage      : {
                entry: () => import(/* webpackChunkName: "balance" */ 'pages/balance/balance')
            },
        BalanceError        : {
                entry: () => import(/* webpackChunkName: "balance" */ 'pages/balance/balance')
            },

        Tasks               : {
                entry: () => import(/* webpackChunkName: "tasks" */ 'pages/tasks/main')
            },

        Calendar            : {
                entry: () => import(/* webpackChunkName: "tasks" */ 'pages/calendar/main')
            },
        MailDomains         : {
                entry: () => import(/* webpackChunkName: "mail-domains" */ 'modules/mailDomains/index')
            },

        // Test                : 'pages/test/index',
        Tariffs             : {
                entry: () => import(/* webpackChunkName: "tariffs" */ 'modules/tariffs/calculator/index')
            },

        // Tickets             : 'pages/tickets/index/index',
        // TicketView          : 'pages/tickets/view/index',

        AccessError         : {
                entry: () => import(/* webpackChunkName: "errors" */ 'pages/access_error')
            },
        AccessErrorLeads    : {
                entry: () => import(/* webpackChunkName: "errors" */ 'pages/access_error_leads')
            },
        AjaxError           : {
                entry: () => import(/* webpackChunkName: "errors" */ 'pages/ajax_error')
            },
        OfflinePage         : {
                entry: () => import(/* webpackChunkName: "errors" */ 'pages/offline')
            },
        Chat                : {
                entry: () => import(/* webpackChunkName: "chat" */ 'modules/chat/index')
            },

        Settings            : {
                entry: () => import(/* webpackChunkName: "settings" */ 'modules/settings/index')
            },
        SettingsIntegrationsAmo : {
                entry: () => import(/* webpackChunkName: "settings-amo" */ 'views/pages/settings/integrations/amo')
            },
        CallsSchemeSettings : {
                entry: () => import(/* webpackChunkName: "telephony-scheme" */ 'modules/callsSchemeSettings/index')
            },
        News                : {
                entry: () => import(/* webpackChunkName: "news" */ 'modules/news/index')
            },
        Autofunnel          : {
                entry: () => import(/* webpackChunkName: "autofunnel" */ 'modules/autofunnel/index')
            },
        SmsSenderNames      : {
                entry: () => import(/* webpackChunkName: "sms" */ 'modules/smsSenderNames/index')
            },

        Reports             : {
                entry: () => import(/* webpackChunkName: "reports" */ 'pages/reports/index')
            },
        ReportsEdit         : {
                entry: () => import(/* webpackChunkName: "reports" */ 'pages/reports/edit')
            },
        Omnidesk         : {
                entry: () => import(/* webpackChunkName: "omnidesk" */ 'pages/omnidesk')
            },
        Tickets         : {
                entry: () => {
                    window.location.href = window.location.origin + '/land/widget/help.php';
                    return new Promise(() => {});
                }
            },

        getPage: function (pageName) {
            let module = this[pageName];
            // const project = app.Collections && app.Collections.Projects && app.Collections.Projects.get(app.currentProjectId);
            const search = app.Models.curProject.get('search') || [];

            if (typeof this[pageName] === 'undefined') {
                return this.Leads();
            } else if (pageName == 'Statistic' || pageName == 'StatisticSource' ) {
                if (search.indexOf('view') >= 0) {
                    module = Object.assign({}, module, {entry: () => import(/* webpackChunkName: "new-stat" */  'modules/statistic/index')});
                }
                // return module();
            } else if (pageName == 'Crater') {
                if (app.AUTH_ID == 9 || (search.indexOf('view') >= 0 && search.indexOf('lead') >= 0)) {
                    module = Object.assign({}, module, {entry: () => import(/* webpackChunkName: "new-crater" */ 'modules/crater/index')});
                }
            } else if (pageName == 'Tariffs') {
                // Старый tariffList свёрстан только под группы 1 и 2, с любой другой группой страница пустая
                const legacyGroup = [1, 2].indexOf(+app.Models.Account.get('tariff_group_id')) >= 0;
                if (!legacyGroup || app.Models.Account.get('registerDate') * 1000 >= new Date(2019,3,9).valueOf()) {
                    module = Object.assign({}, module, {entry: () => import(/* webpackChunkName: "tariffs" */ 'modules/tariffs/tariffListNew/index')});
                } else {
                    module = Object.assign({}, module, {entry: () => import(/* webpackChunkName: "tariffs" */ 'modules/tariffs/tariffList/index')});
                }
            }

            return module;
        }
    };

    var LoaderTPL = require('text!tmpls/loader.tpl').default;
    var Preloader = Marionette.ItemView.extend({
        className: 'inner-content content',
        template: LoaderTPL
    });

    return Marionette.Controller.extend({
        firstRun: true,

        initialize: function () {
            if (window.PRODUCTION && app.Models.User.get('product')
                && app.Models.User.get('product').index_redirect_url)
            {
                var _wr = function(type) {
                    var orig = history[type];
                    return function() {
                        var rv = orig.apply(this, arguments);
                        var e = new Event(type);
                        e.arguments = arguments;
                        window.dispatchEvent(e);
                        return rv;
                    };
                };
                history.pushState = _wr('pushState'), history.replaceState = _wr('replaceState');

                window.addEventListener('replaceState', function(e) {
                    if (!window.location.hash || window.location.hash == '#') {
                        console.log('redirect main page to', app.Models.User.get('product').index_redirect_url);
                        window.location = app.Models.User.get('product').index_redirect_url;
                        window.location.reload();
                    }
                });
            }

            if(app.Models.User.get('product')) {
                document.title = app.Models.User.get('product').name;
                app.storage.write('document_title', document.title)

                if(app.Models.User.get('product').options['favicon']) {
                    var link = document.querySelector("link[rel~='icon']");
                    if (!link) {
                        link = document.createElement('link');
                        link.rel = 'icon';
                        document.getElementsByTagName('head')[0].appendChild(link);
                    }
                    link.href = app.Models.User.get('product').options['favicon'];
                    app.storage.write('document_favicon', link.href)
                }
            } else {
                var link = document.querySelector("link[rel~='icon']");
                if (!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
                link.href = 'favicon.png?02112017';
                app.storage.write('document_favicon', link.href)
            }

            // показываем сайдбар уже после загрузки, чтоб не мелькал
            $('#main-menu').removeClass('loadingHideSidebar');

            if (app.Models.User.get('partner20_status')) {
                Pages.Partners.entry = () => import(/* webpackChunkName: "partners" */ 'pages/partners/partnersNew');
            }
            if (!app.Models.Account.get('tariff_id') && app.isMobile) {
                $('#b-header').hide();
            }


            this.listenTo(app.Models.Account, 'change:balance', this.onChangeAccountBalance);
            app.once('menu:refreshed', this.showMenu, this);
            app.Vents.on('projects:beforeChange:all app:beforeChangeProject', this.showPreloader, this);
            // app.Vents.on('projects:beforeChange:all app:changeProject', this.runLastPage, this);

            app.Vents.on('app:changeProject', function () {
                if (app.global_refresh_menu) {
                    app.global_refresh_menu = false;
                    //app.regionSidebar.show(new SidebarView());
                }
                $('#main-menu').removeClass('hide');
            });
            this.hidePreloader();
            window.addEventListener('message', function(event) {
                if (typeof event.data == 'object') {
                    if (event.data.type == 'showLeadCard') {
                        this.showLeadCard(event.data.id, event.data.lead);
                    }
                    if (event.data.app == 'autofunnel' && event.data.event == 'ON_NOTICE') {
                        app.message[event.data.type](event.data.text);
                    }
                    if (event.data.event == 'ON_PANEL_SHOWED') {
                        app.Vents.trigger('Panel:showed');
                    }

                    if (event.data.event == 'ON_PANEL_HIDED') {
                        app.Vents.trigger('Panel:hided');
                    }
                }
            }.bind(this));
        },

        onChangeAccountBalance: function(model, value) {
            if (app.Models.Account.previous('balance') <= 0 && value > 0) {
                $('body div.page-content').css('margin-left', '');
                $('#main-menu').css('display', 'block');
                $('#b-header').css('display', 'block');
                $('.b-alert-background').hide();
                app.alert.hideWarning();
            }
        },

        run: function (pageName, pageParameters) {
            var that = this;
            var firstPayment = app.Models.Account.get('registerDate') * 1000 >= new Date(2019,3,9).valueOf() && app.Models.Account.get('iwanttariff') && app.Models.Account.get('first_payment');
            // var dateTill = app.Models.Tariff.get('active_till');
            var today = new Date();
            var now = today.getTime();
            var balanceVisited = $.cookie('lpt_balance_visited');

            if (this.firstRun && !firstPayment && !app.Models.Account.get('tariff_id') && !app.Models.Account.get('buy_leads_enabled') && pageName != 'Tariffs' && pageName != 'CodeStandart' && pageName != 'CodeAdvanced' && pageName != 'Partners' && pageName != 'PartnersPromo' && pageName != 'Balance' && pageName != 'Sites' && pageName != 'LeadsBuying' && pageName != 'Tickets') {
                app.Router.navigate('tariffs', true);
                return;
            }
            if (!app.Models.Account.get('tariff_id') && app.Models.Account.get('buy_leads_enabled') && pageName != 'Tariffs' && pageName != 'CodeStandart' && pageName != 'CodeAdvanced' && pageName != 'Partners' && pageName != 'PartnersPromo' && pageName != 'Balance' && pageName != 'Sites' && pageName != 'LeadsBuying' && pageName != 'Tickets') {
                app.Router.navigate('leads/buying', true);
                return;
            }
            if (!app.States.loginFromAdmin &&
                ((!app.Models.Account.get('user_registered_identification') || (this.firstRun && !balanceVisited)) && app.Models.Account.get('balance') <= 0) &&
                pageName != 'Partners' &&
                pageName != 'Balance' &&
                pageName != 'Sites' &&
                pageName != 'LeadsBuying' &&
                pageName != 'Tariffs' && pageName != 'AccessError')
            {
                app.Router.navigate('balance', true);
                return;
            }

            if (firstPayment){
                Backbone.history.navigate('#settings', true);
                Backbone.ajax({
                    url: AppConfig.host + '/rest/tariffs/' + app.Models.Account.get('iwanttariff'),
                    type: 'GET',
                    success: function(response) {
                        if (response) {
                            var price = Math.ceil(response.price/30);
                            ModalsFactory.create('change_tariff', function (Modal) {
                                app.regionModal.show(new Modal({
                                    modalData: {
                                        tariffId: response.id,
                                        tariffName: response.name,
                                        price: price
                                    }
                                }));
                            });
                        }
                    }
                });
                return;
            }

            app.States.enabledAllSites = !!this.enabledAllSites;
            delete this.enabledAllSites;

            var args = Array.prototype.slice.call(arguments);

            app.lastView = {
                pageName: pageName,
                args: pageParameters,
                url: window.location.hash
            };
            $.cookie('LPT_last_page', JSON.stringify(app.lastView));
            if (pageName != 'Tariffs' && !app.Models.Account.get('tariff_id')) {
                app.showAlerts({danger: ['activation']});
            } else if ($('.alert_activation_danger').length) {
                app.alert.hideWarning();
            }

            app.Vents.trigger('projects:select:update');

            app.regionContent.show(new Preloader());

            let pageSettings = Pages.getPage(args.shift());

            pageSettings.entry().then(function (Module) {
                app.___alerts.then((alerts) => {
                  app.__innerFunds(alerts)
                })

                var hash = (!window.location.hash || window.location.hash == '#') ? '#leads' : (window.location.hash.indexOf('#staff/edit') >= 0) ? '#staff' : window.location.hash;
                var currentMenu = _.sortBy(_.where(app.menu, {url: hash}), 'parent_id').reverse();
                var product = app.Models.User.get('product');

                if (currentMenu.length && currentMenu[0].html_big && !currentMenu[0].button_clicked && product && product.options['show_helpers']) {
                    app.regionContent.show(new AboutPage({
                        menu: currentMenu[0]
                    }))
                } else {
                    pageParameters = pageParameters || {};
                    pageParameters.pageTitle = currentMenu.length ? currentMenu[0].name : '';
                    pageParameters.aboutPopup = currentMenu.length && product && product.options['show_helpers'] ? currentMenu[0].html_popup : '';
                    var page = new Module.default(pageParameters);
                    app.regionContent.show(page);
                    app.curPage = page;
                }

              var blocked = false;

              if (app.Models.Account.get('functions_disallowed').length >= 0) {
                let disallowedFunctions = app.Models.Account.get('functions_disallowed');

                for (const disallowedFunction of disallowedFunctions) {
                  for (const disallowedFunctionUrl of disallowedFunction.urls) {
                    if (disallowedFunctionUrl === hash || disallowedFunctionUrl === window.location.hash || window.location.href.indexOf(disallowedFunctionUrl) > -1) {
                      console.error('[[[[[[[[[page disallowed', disallowedFunctionUrl, hash, window.location.hash, window.location.href)

                      ModalsFactory.create('content_dialog', function(Modal) {
                        var modal =  new Modal({
                          preventOverlayClick: true,
                          closeOnEsc: false,
                          modalData: {
                            width: 1100,
                            content: disallowedFunction.popup_code,
                            hideTitle: true,
                            hideClose: true,
                            background: '#fff'
                          }
                        });
                        app.regionModal.show(modal);
                        modal.$('.js-arcticmodal').click(function() {
                          var template = $(this).data('template');

                          if (modal.$('#' + template).length) {
                            modal.$('#' + template).arcticmodal();
                          }
                        });
                        modal.$('.js-start-use-page').click(function(event) {
                          event.preventDefault();
                          if ($(this).data('redirect')) {
                            Backbone.history.navigate($(this).data('redirect'), true);
                          } else {
                            Backbone.history.navigate('#tariffs', true);
                          }
                        })
                      }.bind(this));
                      break;
                    }
                  }
                }
              }

                $('#b-content > div').removeClass('hide').addClass('animated fadeIn');

                if (
                    !app.States.loginFromAdmin &&
                    (!app.Models.Account.get('user_registered_identification') && app.Models.Account.get('balance') <= 0) || pageName == 'PollPage'
                ) {
                    blocked = true;
                }
                if (blocked && (pageName != 'Partners' && pageName != 'Balance' && pageName != 'Tariffs' && pageName != 'Tickets' && pageName != 'PollPage')) {
                    $('body').removeClass('blockedView').css('overflow', 'hidden');
                    $('body div.page-content').css('margin-left', '0');
                    $('#main-menu').css('display', 'none');
                    $('#b-header').css('display', 'none');
                    if (pageName != 'PollPage') {
                        $('#b-content').css('padding-top', '26px');
                    }
                    $('.b-alert-background').show();
                } else {
                    $('.b-alert-background').hide();
                }

                if (that.firstRun) {
                    app.Views.Header = new HeaderView();
                    app.regionSidebar.show(new SidebarView());
                    app.regionHeader.show(app.Views.Header);
                    that.getCounter();
                    that.firstRun = false;

                    // if (!$.cookie('auth_token')) {
                    //     ModalsFactory.create('content_dialog', Modal => {
                    //         var modal = new Modal({
                    //             modalData: {
                    //                 content: `<div style="font-size: 24px;line-height: 32px;padding: 24px 84px 16px 32px;overflow-wrap: break-word;">Разрешите использование файлов cookie</div>
                    //                         <button type="button" class="close arcticmodal-close" data-dismiss="modal" aria-hidden="true" style="display: flex;position: absolute;right: 36px;top: 26px;padding:10px;z-index:1">
                    //                             <svg style="width: 12px;height: 12px;" fill="currentColor" fill-rule="evenodd" stroke-linejoin="round" clip-rule="evenodd" viewBox="0 0 10 10">
                    //                             <polygon id="Path" points="6 5 10 9 9 10 5 6 1 10 0 9 4 5 0 1 1 0 5 4 9 0 10 1"></polygon>
                    //                             </svg>
                    //                         </button>
                    //                         <div style="padding: 0px 36px 40px 32px;">
                    //                             Для корректной работы сайта, пожалуйста, отключите в настройках браузера блокировку файлов cookie
                    //                             <center><img src="img/nocookie.png" style="width:400px; margin-top: 16px;" /></center>
                    //                         </div>
                    //                             `,
                    //                 hideTitle: true,
                    //                 hideClose: true,
                    //                 background: '#fff'
                    //             }
                    //         });
                    //         app.regionModal.show(modal);
                    //     })
                    // }
                }

                if (!app.Models.Account.get('tariff_id') && app.isMobile) {
                    $('.page-content .inner-content.content').css('paddingTop', '0');
                    $('.page-content').css('marginBottom', '0px');
                }

                if (pageSettings.hideHeader) {
                    $('body').addClass('hidden-header');
                } else {
                    $('body').removeClass('hidden-header');
                }

                // that.checkTariff.call(that, pageName);
            });
        },

        getCounter: function() {
            Backbone.ajax({
                url: AppConfig.host + '/chat/ids',
                type: 'GET',
                contentType: 'application/json',
                data: {filter:JSON.stringify({"unseen":1, "count":1})},
                success: function (response) {
                    if (response.total) {
                        app.Models.Counters.set('#chat', response.total)
                    }
                }
            })
        },

        // checkTariff: function(pageName) {
        //     var sections = tariffSections[pageName];
        //     var activeModules = 0;
        //     if (sections && (!app.Models.Account.get('tariff_id') || app.Models.Account.get('useTariffCalculator'))) {
        //         app.Models.Tariff.get('modules').each(function(module) {
        //             if (sections.indexOf(module.get('name')) >= 0 && !!module.get('value')) {
        //                 activeModules++
        //             }
        //         });

        //         if ((!activeModules || !app.Models.Account.get('tariff_id')) && !(app.Models.Account.get('buy_leads_enabled') && pageName == 'LeadsBuying')) {
        //             this.showPageInfo(pageName);
        //         }
        //     }
        // },

        // showPageInfo: function(pageName) {
        //     var route = location.hash.split('/');
        //     var modules = tariffSections[pageName];
        //     if (route.length == 3) {
        //         route[2] = 100500
        //     }
        //     Backbone.ajax({
        //         url  : AppConfig.host + '/rest/help/popup',
        //         type : 'GET',
        //         data: {
        //             route: route.join('/') || '#leads'
        //         }
        //     }).then(function(response) {
        //         ModalsFactory.create('page_info', function (Modal) {
        //             var modal = new Modal({
        //                 modalData: {
        //                     content: response.content,
        //                     height: response.height,
        //                     width: response.width,
        //                     modules: modules
        //                 }
        //             });
        //             app.regionModal.show(modal);
        //         })
        //     })
        // },

        reloadRegionContent: function () {
            //app.on('menu:refreshed', this.runLastPage, this);
        },

        runLastPage: function (id, notReload) {
            // var urlPage = app.Router.getPageNameByUrl(location.hash.slice(1));
            if (!notReload) {
                // if (this[urlPage]) {
                //     this[urlPage]();
                // } else {
                    Backbone.history.loadUrl(Backbone.history.fragment);
                // }
                app.off('menu:refreshed', this.runLastPage, this);
            }
        },

        introAnimation: function () {
            this.$mainLoading = $('#main-loading');

            this.$mainLoading.removeClass('fadeIn').addClass('fadeOut');

            setTimeout(function () {
                this.$mainLoading.addClass('hide');
            }.bind(this), 400);

            $('#b-header').removeClass('hide');//.addClass('animated fadeIn');

            $('#b-content > div').removeClass('hide').addClass('animated fadeIn');
            app.loaded = true;
        },

        showPreloader: function () {
            if (this.preloaderIsVisible) return;

            this.$mainLoading.removeClass('fadeOut hide').addClass('fadeIn');
            app.on('menu:refreshed', this.hidePreloader, this);
            this.preloaderIsVisible = true;
        },

        hidePreloader: function () {
            app.off('menu:refreshed', this.hidePreloader, this);
            setTimeout(function () {
                this.introAnimation();
                this.preloaderIsVisible = false;
            }.bind(this), 2000);
        },

        showMenu: function () {
            var
                that = this,
                $mainMenu = $('#main-menu');
            $mainMenu.removeClass('animated slideInLeft');

            setTimeout(function () {
                $mainMenu.removeClass('hide');//.addClass('animated slideInLeft');
                that.introAnimation();
            }, 100);
        },

        accessForbidden: function (pages) {
            pages = pages || [];
            var forbidden = pages.map(function(page) {
                    return app.checkAccess(page);
                })
                .reduce(function(acc, item) {
                    return acc && item;
                });

            if (forbidden) {
                this.AccessError();
            }

            return forbidden;
        },

        showLeadCard: function (id, lead) {
            require(['pages/leads/card'], function(Card) {
                var leadCard = new Card({
                    id: id,
                    isSideCard: true,
                    isDeal: lead && lead.isDeal
                });
                app.Vents.trigger('sideCard:show', leadCard, {hideClose: false});
            })
        },

        StatsSource: function (source_id) {
            if (this.accessForbidden(['advertising_analytics'])) return;
            this.run('StatsSource', {id: source_id});
        },

        Statistic: function (params) {
            //if(app.AUTH_ID == 9) {
            if (this.accessForbidden(['advertising_analytics'])) return;

            var queryParams = params && params.match(/([^=&]+)=([^&]*)/gi) || [];
            var options = {};
            _.each(queryParams, function (param) {
                var option = param.split('=');
                options[option[0]] = option[1];
            });

            this.enabledAllSites = false;
            this.run('Statistic', options);
        },
        StatisticSource: function (sourceId) {
            if (this.accessForbidden(['advertising_analytics'])) return;
            this.enabledAllSites = false;
            this.run('StatisticSource', {id: sourceId});
        },
        StatisticDynamics: function () {
            if (this.accessForbidden(['advertising_analytics'])) return;
            this.run('StatisticDynamics');
        },
        StatisticLvl2: function () {
            if (this.accessForbidden(['advertising_analytics'])) return;
            this.run('StatisticLvl2')
        },
        WidgetCallback: function () {
            if (this.accessForbidden(['callback'])) return;
            this.run('WidgetCallback');
        },
        WidgetOffers: function () {
            if (this.accessForbidden(['callback'])) return;
            this.run('WidgetOffers');
        },
        WidgetSocial: function () {
            if (this.accessForbidden(['vk_hunter'])) return;
            this.run('WidgetSocial');
        },
        WidgetSpeech: function () {
            if (this.accessForbidden(['callback'])) return;
            this.run('WidgetSpeech');
        },
        WidgetGeolocation: function () {
            if (this.accessForbidden(['advertising_analytics'])) return;
            this.run('WidgetGeolocation');
        },
        WidgetBlacklist: function () {
            if (this.accessForbidden(['virtual_pbx'])) return;
            this.run('WidgetBlacklist');
        },

        PollPage: function() {
            if (app.Models.User.get('phone_confirmed')) {
                Backbone.history.navigate('#leads', true);
            } else {
                window.OmniWidgetApi && window.OmniWidgetApi.call('hide_btn');
                $('#omni_widget_hint').hide();
                this.run('PollPage');
            }
        },

        Popdom: function () {
            if (this.accessForbidden(['callback'])) return;
            this.run('WidgetPopdom')
        },
        PopdomEdit: function () {
            if (this.accessForbidden(['callback'])) return;
            this.run('WidgetPopdomEdit')
        },
        PopdomStats: function () {
            if (this.accessForbidden(['callback'])) return;
            this.run('WidgetPopdomStats')
        },

        Leads: function (params) {
            if (app.curPage && app.curPage.pageName == 'Leads' && (!params || params != 'reload' && params.indexOf('filter') == -1)) {
                return;
            }
            if (this.accessForbidden(['leads','deals'])) return;
            var queryParams = params && params.match(/([^=&]+)=([^&]*)/gi) || [];
            var options = {};
            _.each(queryParams, function (param) {
                var delimiterPos = param.indexOf('=');
                var optionName = param.substring(0, delimiterPos);
                var optionValue = param.substring(delimiterPos + 1);

                if (delimiterPos) {
                    try {
                        optionValue = JSON.parse(decodeURI(optionValue));
                    } catch (err) {}
                    options[optionName] = optionValue;
                }
            });
            this.run('Leads', options);
        },
        LeadsImport: function () {
            if (this.accessForbidden([I18n.menu.import])) return;
            this.run('LeadsImport');
        },
        LeadsExport: function () {
            if (this.accessForbidden([I18n.menu.export])) return;
            this.run('LeadsExport');
        },
        LeadsCard: function (cardId) {
            if (this.accessForbidden(['leads','deals'])) return;
            this.run('LeadsCard', {
                id: cardId,
                isDeal: false
            });
        },

        LeadsBuying: function() {
            if (app.checkAccess('leads_buying')) {
                this.AccessError();
                return;
            }
            this.run('LeadsBuying');
        },

        Deals: function (params) {
            if (this.accessForbidden(['deals'])) return;
            var queryParams = params && params.match(/([^=&]+)=([^&]*)/gi) || [];
            var options = {};
            _.each(queryParams, function (param) {
                var option = param.split('=');
                try {
                    option[1] = JSON.parse(decodeURI(option[1]));
                } catch (err) {}
                options[option[0]] = option[1];
            });
            this.run('Deals', options);
        },
        DealsImport: function () {
            if (this.accessForbidden([I18n.menu.import_deals])) return;
            this.run('DealsImport', {isDeal: true});
        },
        DealsExport: function () {
            if (this.accessForbidden([I18n.menu.export_deals])) return;
            this.run('DealsExport', {isDeal: true});
        },
        DealsCard: function (cardId) {
            if (this.accessForbidden(['deals'])) return;
            this.run('DealsCard', {
                id: cardId,
                isDeal: true
            });
        },

        Constructor: function () {
            if (this.accessForbidden(['crm_settings'])) return;
            this.run('Constructor')
        },

        Crater: function () {
            if (this.accessForbidden(['crater'])) return;
            this.run('Crater');
        },
        CraterEdit: function () {
            if (this.accessForbidden(['edit_steps'])) return;
            this.run('CraterEdit');
        },
        CraterDecomposition: function () {
            //if (this.accessForbidden(['crater'])) return;
            this.run('CraterDecomposition');
        },

        Staff: function () {
            if (this.accessForbidden(['staff'])) return;
            this.run('Staff');
        },
        StaffEdit: function (id) {
            if (!id && !app.Models.User.get('employee_access_edit') && app.Models.User.get('profile_type') !=0 || id == app.Models.User.id && !app.Models.User.get('profile_access') || id != app.Models.User.id && !app.Models.User.get('employee_access_edit')) {
                this.AccessError();
                return;
            }

            this.run('StaffEdit', {id: id});
        },
        StaffStatistic: function () {
            if (this.accessForbidden(['staff'])) return;
            this.run('StaffStatistic');
        },
        StaffChangePassword: function () {
            if (!app.Models.User.get('profile_access')) return;
            this.run('StaffChangePassword');
        },
        StaffSecurity: function () {
            if (this.accessForbidden(['staff'])) return;
            this.run('StaffSecurity');
        },
        StaffWorklog: function () {
            this.run('StaffWorklog');
        },
        TelephonyOnline: function () {
            if (this.accessForbidden(['calltracking'])) return;
            this.run('TelephonyOnline');
        },
        TelephonyOffline: function () {
            if (this.accessForbidden(['calltracking'])) return;
            this.run('TelephonyOffline');
        },
        TelephonyRedirection: function () {
            if (this.accessForbidden(['virtual_pbx'])) return;
            this.run('TelephonyRedirection');
        },
        TelephonyNumbers: function(params) {
            if (this.accessForbidden(['virtual_pbx'])) return;
            var queryParams = params && params.match(/([^=&]+)=([^&]*)/gi) || [];
            var options = {};
            _.each(queryParams, function (param) {
                var option = param.split('=');
                try {
                    option[1] = JSON.parse(decodeURI(option[1]));
                } catch (err) {}
                options[option[0]] = option[1];
            });
            this.run('TelephonyNumbers', options);
        },
        TelephonyWelcome: function () {
            if (this.accessForbidden(['virtual_pbx'])) return;
            this.run('TelephonyWelcome');
        },
        TelephonyDetails: function (params) {
            if (this.accessForbidden(['virtual_pbx'])) return;
            var queryParams = params && params.match(/([^=&]+)=([^&]*)/gi) || [];
            var options = {};
            _.each(queryParams, function (param) {
                var option = param.split('=');
                try {
                    option[1] = JSON.parse(decodeURI(option[1]));
                } catch (err) {}
                options[option[0]] = option[1];
            });
            this.run('TelephonyDetails', options);
        },
        TelephonyComands: function () {
            if (this.accessForbidden(['virtual_pbx'])) return;
            this.run('TelephonyComands');
        },
        TelephonyRobot: function () {
            if (this.accessForbidden(['virtual_pbx'])) return;
            this.run('TelephonyRobot');
        },
        TelephonyCalltracking: function () {
            if (this.accessForbidden(['calltracking'])) return;
            this.run('TelephonyCalltracking');
        },
        TelephonySimcards: function () {
            if (this.accessForbidden(['virtual_pbx'])) return;
            this.run('TelephonySimcards');
        },
        Partners: function () {
            if (this.accessForbidden(['partners'])) return;
            this.run('Partners');
        },
        PartnersPromo: function () {
            if (this.accessForbidden(['partners'])) return;
            this.run('PartnersPromo');
        },
        Contacts: function (query) {
            if (this.accessForbidden(['contacts'])) return;
            // Multic #457: список контактов переехал в новый ЛК; старый — только по #contacts?admin
            if (!/(^|&)admin(=|&|$)/.test(query || '')) {
                window.location.replace('/land/lk/crm/');
                return;
            }
            this.enabledAllSites = false;
            this.run('Contacts');
        },
        ContactsCard: function (card_id) {
            if (this.accessForbidden(['contacts'])) return;
            this.enabledAllSites = false;
            this.run('ContactsCard', {id: card_id});
        },
        CodeAdvanced: function () {
            !this.accessForbidden(['code']) && this.run('CodeAdvanced')
        },
        CodeStandart: function () {
            //!this.accessForbidden(['code']) &&  this.run('CodeStandart')
            this.run('CodeStandart')
        },
        Balance: function (params) {
            var today = new Date();

            if (this.accessForbidden(['balance'])) return;
            const expireDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);

            document.cookie = `lpt_balance_visited=true; expires=${expireDate.toUTCString()}`;
            app.Events.BalanceResponse = 'none';

            var pageParams;
            if (params) {
                var qs = params.replace(/^\?/, '');
                var clidMatch = qs.match(/(?:^|&)clid=([^&]*)/);
                if (clidMatch) {
                    var clid = decodeURIComponent(clidMatch[1]).replace(/^["']|["']$/g, '');
                    pageParams = { clid: clid };
                }
            }

            this.run('Balance', pageParams);
            if (params && params == 'show-add-funds') {
                let event = $.Event();
                event.currentTarget = $({}).data({
                    modal: 'add_funds',
                    paySumm: app.Models.Account.get('payment_month')
                });
                app.Vents.trigger('modal:showModal', event);
            }
        },
        BalanceSuccess: function () {
            if (this.accessForbidden(['balance'])) return;
            app.Events.BalanceResponse = 'success';
            this.run('Balance');
        },
        BalanceError: function () {
            if (this.accessForbidden(['balance'])) return;
            app.Events.BalanceResponse = 'error';
            this.run('Balance');
        },

        Tariffs: function () {
            this.run('Tariffs')
        },

        Sites: function () {
            if (this.accessForbidden(['sites'])) return;
            this.run('Sites')
        },

        Reports: function() {
            if (this.accessForbidden(['advertising_analytics'])) return;
            this.run('Reports');
        },

        ReportsEdit: function(id) {
            if (this.accessForbidden(['advertising_analytics'])) return;
            this.run('ReportsEdit',  {id: id});
        },

        Omnidesk: function(id) {
            this.run('Omnidesk');
        },

        Tickets: function(id) {
            this.run('Tickets');
        },

        Logout: function () {
            //this.run('Logout')
            Backbone.ajax({
                type: 'GET',
                url: AppConfig.host + '/rest/system/logout',
                success: function (response) {
                    if (response.status == 1) {
                        app.storage.remove(app.storage.read('authToken'));
                        app.storage.remove('authToken');
                        app.storage.remove('auth_id');
                        app.storage.remove('wsToken');
                        app.storage.remove('user');
                        app.storage.remove('user-access');
                        sessionStorage.removeItem('projectId');
                        sessionStorage.removeItem('userId');
                        window.location.href = response.result.data.redirect;
                    }
                },
                error: function (xhr) {
                    if (xhr.responseText !== undefined) {
                        var response = $.parseJSON(xhr.responseText);
                        if (response.status == 0) {
                            app.message.error(response.message || I18n.basic.oops);
                        }
                    }
                }
            });
        },
        Code: function () {
            this.run('Code')
        },

        Tasks: function (taskId) {
            var route = '#calendar';
            if (taskId) {
                route += '/task/' + taskId;
            }
            Backbone.history.navigate(route, true);
        },

        Chat: function(id, query) {
            if (this.accessForbidden(['chat'])) return;
            var filter;

            try {
                filter = JSON.parse(decodeURI(query));
            } catch (err) {}
            this.run('Chat', {id, filter});
        },

        Calendar: function (taskId) {
            if (this.accessForbidden(['tasks'])) return;
            if (location.hash.indexOf('#calendar/task') == 0) {
                window.history.replaceState({}, document.title, location.href.split('#')[0] + '#calendar');
            }
            this.enabledAllSites = true;
            this.run('Calendar', {id: taskId})
        },

        MailDomains: function(id) {
            this.run('MailDomains', {id})
        },

        Test: function () {
            this.run('Test')
        },
        TestAdmins: function () {
            this.run('TestAdmins')
        },
        TestTickets: function () {
            this.run('TestTickets')
        },

        AccessError: function () {
            this.run('AccessError')
        },

        AccessErrorLeads: function (options) {
            this.run('AccessErrorLeads', options)
        },

        AjaxError: function (options) {
            this.run('AjaxError', options)
        },

        OfflinePage: function (options) {
            this.run('OfflinePage', options)
        },

        Settings: function (tab) {
            if (this.accessForbidden(['settings'])) return;
            this.run('Settings', {
                tab: tab
            });
        },
        CallsSchemeSettings: function (id) {
            if (this.accessForbidden(['settings'])) return;
            this.run('CallsSchemeSettings', {id});
        },
        News: function() {
            this.run('News');
        },
        Autofunnel: function() {
            if (this.accessForbidden(['autofunnel'])) return;
            this.run('Autofunnel');
        },
        SmsSenderNames: function() {
            if (this.accessForbidden(['settings'])) return;
            this.run('SmsSenderNames')
        },
        
        SettingsIntegrationsAmo: function() {
            if (this.accessForbidden(['settings'])) return;
            this.run('SettingsIntegrationsAmo');
        }
    });
});
